const firebaseConfig = {
    apiKey: "AIzaSyC3fab-pLNy0G1HOtE3P8DGz7eVDaXBXZs",
    authDomain: "drone-peak.firebaseapp.com",
    projectId: "drone-peak",
    storageBucket: "drone-peak.appspot.com",
    messagingSenderId: "255567159027",
    appId: "1:255567159027:web:f689ad2478b52b2120e186"
};
export default firebaseConfig;